<app-error-shell>
  <div class="error-page">
    <span class="error-page__icon" aria-hidden="true">🔒</span>
    <span class="error-page__code">403</span>
    <h1 class="error-page__title">{{ 'errors.access_denied.title' | translate }}</h1>
    <p class="error-page__subtitle">{{ 'errors.access_denied.subtitle' | translate }}</p>
    <a [routerLink]="authService.isAuthenticated() ? routes.DASHBOARD : routes.HOME" class="error-page__cta">
      {{ (authService.isAuthenticated() ? 'errors.cta.go_to_dashboard' : 'errors.cta.go_to_home') | translate }} ›
    </a>
  </div>
</app-error-shell>
